import classNames from 'classnames';
import { defaultTo, omit } from 'lodash-es';
import type { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';
import { Tooltip } from './tooltip';

type ButtonVariant = 'primary' | 'tertiary' | 'light' | 'danger' | 'success';

type NativeButtonProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export type ButtonProps = NativeButtonProps & {
  variant: ButtonVariant;
  tooltip?: string;
};

export const Button = (props: ButtonProps) => (
  <Tooltip content={props.tooltip}>
    <button
      {...omit(props, 'variant')}
      type={defaultTo(props.type, 'button')}
      className={classNames(
        'p-2 rounded-lg text-sm text-center focus:outline-none focus:ring-1 focus:ring-medium',
        props.className,
        {
          // primary
          'text-contrast bg-primary hover:text-contrast hover:bg-primary-tint active:bg-primary-shade': (props.variant === 'primary' && !props.disabled),
          'bg-primary-light text-medium bg-transparent cursor-default': (props.variant === 'primary' && props.disabled),
          // TODO define disabled styles for primary
          // tertiary
          'text-dark bg-light hover:text-dark hover:bg-light-tint active:bg-light-shade': (props.variant === 'tertiary' && !props.disabled),
          'bg-light-shade text-medium bg-transparent cursor-default': (props.variant === 'tertiary' && props.disabled),
          // danger
          'text-contrast bg-danger hover:text-contrast hover:bg-danger-tint active:bg-danger-shade': (props.variant === 'danger' && !props.disabled),
          // success
          'text-contrast bg-success hover:text-contrast hover:bg-success-tint active:bg-success-shade': (props.variant === 'success' && !props.disabled),
          // TODO define disabled styles for danger
          // light
          'text-dark bg-transparent hover:text-dark hover:bg-light-tint  active:bg-light-shade': (props.variant === 'light' && !props.disabled),
          'text-medium bg-transparent cursor-default': (props.variant === 'light' && props.disabled),
        },
      )}>
      {props.children}
    </button>
  </Tooltip>
);

export default Button;
